export const FETCH_COLLECTION = "FETCH_COLLECTION";
export const START_FETCHING_COLLECTION = "START_FETCHING_COLLECTION";
export const END_FETCHING_COLLECTION = "END_FETCHING_COLLECTION";
